function getErrorMessageFromFirebaseError(firebaseError) {
  const errorTemplate = "Unsupported field value: undefined (found in field ";
  let errorMessage = "" + firebaseError;
  const templatePosition = errorMessage.indexOf(errorTemplate);
  if (templatePosition != -1) {
    errorMessage = errorMessage.substring(templatePosition + errorTemplate.length);
    const nextSpacePosition = errorMessage.indexOf(" ");
    errorMessage = errorMessage.substring(0, nextSpacePosition);
    errorMessage = "El campo " + errorMessage + " no puede ser nulo";
  }
  return errorMessage;
}

function checkEconomicDataForShip(howsCalling, ship) {
  //console.log(
  //  "************* utils.checkEconomicDataForShip desde",
  //  howsCalling,
  //  "para buque",
  //  ship,
  //  "con",
  //  ship.configurations.length,
  //  "configuraciones"
  //);

  ship.configurations.forEach((configuration) => {
    if (!configuration.economicData) {
      console.log("¡¡¡¡¡OJO!!!!! Este buque no tiene parte económica");
    }
  });
}

module.exports = { getErrorMessageFromFirebaseError, checkEconomicDataForShip };
